<template>
	<div class="mt-5">
		<div class="bump-information">
			<div class="bump-actions d-flex">
				<div class="form-arrow">
					<img src="https://cdn.orderonline.id/arrow.gif" alt="" />
				</div>
				<label class="bump-check m-0">
					<div class="custom-control custom-checkbox large white">
						<input
							type="checkbox"
							class="custom-control-input ooef-check-bump"
							v-model="inputValue"
							@input="$emit('input', $event.target.value)"
						/>
						<div class="custom-control-label">
							{{ bump.data.checkbox_label }}
						</div>
					</div>
				</label>
			</div>
			<div class="bump-body">
				<div class="bump-title">
					{{ bump.data.title }}
				</div>
				<img :src="bump.data.image" class="img-responsive bump-image" />
				<div class="bump-description" v-html="bump.data.description">
					<!-- {{ bump.data.description }} -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormBump',
	props: {
		bump: {
			type: Object,
			default: null,
		},
		isBumpChecked: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isLoading: false,
		};
	},
	computed: {
		inputValue: {
			get() {
				return this.isBumpChecked;
			},
			set(val) {
				this.$emit('input', val);
			},
		},
	},
};
</script>

<style>

</style>
